import _IconError from "@arco-design/iconbox-react-m4b-next/esm/IconError";
import _IconWarning from "@arco-design/iconbox-react-m4b-next/esm/IconWarning";
import _IconSuccess from "@arco-design/iconbox-react-m4b-next/esm/IconSuccess";
import _IconInfo from "@arco-design/iconbox-react-m4b-next/esm/IconInfo";
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import cx from 'classnames';
import { getGlobalContext } from '@m4b-design/config-provider';
import { ArcoIconWrapper } from '@m4b-design/utils';
var iconMap = {
  info: function info(props) {
    return /*#__PURE__*/React.createElement(ArcoIconWrapper, __assign({
      Icon: _IconInfo
    }, props));
  },
  success: function success(props) {
    return /*#__PURE__*/React.createElement(ArcoIconWrapper, __assign({
      Icon: _IconSuccess
    }, props));
  },
  warning: function warning(props) {
    return /*#__PURE__*/React.createElement(ArcoIconWrapper, __assign({
      Icon: _IconWarning
    }, props));
  },
  error: function error(props) {
    return /*#__PURE__*/React.createElement(ArcoIconWrapper, __assign({
      Icon: _IconError
    }, props));
  }
};
export function normalizeConfig(props) {
  var globalPrefixCls = getGlobalContext().prefixCls;
  var _a = props.size,
    size = _a === void 0 ? 'default' : _a,
    subTitle = props.subTitle,
    footerText = props.footerText,
    title = props.title,
    footer = props.footer,
    icon = props.icon,
    _b = props.autoFocus,
    autoFocus = _b === void 0 ? false : _b,
    restProps = __rest(props, ["size", "subTitle", "footerText", "title", "footer", "icon", "autoFocus"]);
  var prefixCls = "".concat(globalPrefixCls, "-modal");
  var realIcon;
  if (icon) {
    if (typeof icon === 'string') {
      var IconComponent = iconMap[icon];
      if (IconComponent) {
        realIcon = /*#__PURE__*/React.createElement(IconComponent, {
          className: "".concat(prefixCls, "-title-icon"),
          style: {
            stroke: 'none'
          }
        });
      }
    } else {
      realIcon = icon;
    }
  }
  var realTitle = null;
  if (title || subTitle) {
    if (subTitle) {
      realTitle = /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-with-subtitle")
      }, /*#__PURE__*/React.createElement("div", null, realIcon ? /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-title")
      }, realIcon, /*#__PURE__*/React.createElement("span", null, title)) : title, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-sub-title")
      }, subTitle)));
    } else {
      realTitle = realIcon ? /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-title")
      }, realIcon, /*#__PURE__*/React.createElement("span", null, title)) : title;
    }
  }
  var realFooter;
  if (footer !== undefined) {
    realFooter = footer;
  } else {
    realFooter = function realFooter(cancelButtonNode, okButtonNode) {
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-footer")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-footer-text")
      }, footerText), !restProps.hideCancel && cancelButtonNode, okButtonNode);
    };
  }
  return __assign(__assign({
    maskClosable: false,
    closable: true
  }, restProps), {
    cancelButtonProps: __assign({
      size: 'large'
    }, props.cancelButtonProps || {}),
    okButtonProps: __assign({
      size: 'large'
    }, props.okButtonProps || {}),
    className: cx(prefixCls, restProps.className, "".concat(prefixCls, "-size-").concat(size), realIcon && "".concat(prefixCls, "-with-icon")),
    title: realTitle,
    footer: realFooter,
    simple: false,
    icon: null,
    autoFocus: autoFocus
  });
}